import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from 'src/constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface GeneralInfoRes {
  name: string
  vesselName: string
  imo: string
  imoNumber: string
  vesselCode: string
  vesselId: string
  tramosCode: string
  poolPartner: string
  poolPartnerCode: string
  axCode: string
  buildYear: string
  builder: string
  flag: string
  dwt: string
  length: string
  iceClass: string
  imoClass: string
  dimensionsSummerLoadlineDraft: string
  hasScrubber: boolean
  scrubber: string
  cbm: number
}

export function useGetGeneralInfo({ vessel }: { vessel: string | undefined }) {
  const fetchRequest = useFetch<GeneralInfoRes>()
  return useQuery({
    queryKey: ['/general-info', vessel],
    queryFn: () => fetchRequest(`${apiBase()}/vessels/${vessel}/general-info`),
    staleTime: tenMinutes,
    enabled: !!vessel,
  })
}
